import { useQuery } from 'react-query';
import { SrxApi } from '../../api/SrxApi';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';

function useSearchRx(
    value,
    selectedDropdownValue,
    user,
    dispensedt,
    setOpenDispenseDateModal,
    endpoint,
    searchAttempt = 0,
    onNotReturnableDecision
) {
    const { pathname } = useLocation();

    const query = useQuery({
        queryKey: ['orderReturnData', pathname, value, selectedDropdownValue, user?.userId, dispensedt, endpoint, searchAttempt ],
        queryFn: async () => {
            if (!value || !user?.userId) return null;

            try {
                const userName = user?.userName || user?.username || user?.email || '';
                const response = await SrxApi.get(endpoint, {
                    params: {
                        rxNo: value ?? '',
                        ...(selectedDropdownValue
                            ? { facId: selectedDropdownValue }
                            : userName
                              ? { userName }
                              : {}),
                        userId: user.userId,
                        dispensedt: dispensedt,
                    },
                });

                const resultData = response?.data?.result || [];

                const firstItem = resultData[0];
                
                const isOrderReturnLookup = endpoint?.includes('/orderReturns/');
                const isDestructionLookup = endpoint?.includes('/destructions/');
                const controlledDrugValue = firstItem?.ControlledDrug ?? firstItem?.controlledDrug;
                const controlledDrugAllowed =
                    controlledDrugValue === undefined ? true : Boolean(controlledDrugValue);

                if (isOrderReturnLookup && firstItem?.allowReturn === false) {
                    Swal.fire({
                        icon: 'warning',
                        html: `${
                            firstItem?.blockReturnReason ? `${firstItem.blockReturnReason}<br/><br/>` : ''
                        }Would you like to add for destruction only?`,
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        customClass: {
                            confirmButton: 'custom-green-button',
                            cancelButton: 'custom-cancel-button',
                        },
                    }).then((result) => {
                        if (onNotReturnableDecision) onNotReturnableDecision(result.isConfirmed);
                    });
                } else if (isDestructionLookup && controlledDrugValue === false && firstItem?.allowReturn === true) {
                    Swal.fire({
                        icon: 'warning',
                        text: firstItem?.blockReturnReason,
                        customClass: {
                            confirmButton: 'custom-green-button',
                        },
                    });
                } else if (isDestructionLookup && !controlledDrugAllowed) {
                    Swal.fire({
                        icon: 'info',
                        text: firstItem?.blockReturnReason,
                        customClass: {
                            confirmButton: 'custom-green-button',
                        },
                    });
                } else if (isDestructionLookup && controlledDrugValue === true) {
                    Swal.fire({
                        icon: 'info',
                        text: 'This drug may not be a controlled drug.',
                        customClass: {
                            confirmButton: 'custom-green-button',
                        },
                    });
                } else if (resultData.length === 2) {
                    setOpenDispenseDateModal(true);
                }

                return resultData;
            } catch (error) {
                if (error?.response?.status === 400) {
                    Swal.fire({
                        icon: 'info',
                        text: `${
                            error?.response?.data?.message ||
                            error?.response?.data?.errors?.message ||
                            (error?.response?.data?.errors?.facId &&
                                'Please select a facility before performing the search.') ||
                            'Something went wrong while fetching data.'
                        }`,
                        customClass: {
                            confirmButton: 'custom-green-button',
                        },
                    });
                }
                return [];
            }
        },
        staleTime: 0,
        cacheTime: 0,
        refetchOnMount: 'always',
    });

    return {
        searchRxData: query.data || [],
        isSearchRxLoading: query.isLoading,
        isSearchRxError: query.isError,
        error: query.error,
    };
}

export default useSearchRx;